import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";

import Layout from "@/components/tavern/Layout";
import Home from "@/pages/Home";
import Welcome from "@/pages/Welcome";
import Story from "@/pages/Story";
import About from "@/pages/About";
import Adventures from "@/pages/Adventures";
import DragonsRoost from "@/pages/DragonsRoost";
import MessengerRavens from "@/pages/MessengerRavens";
import StarCharts from "@/pages/StarCharts";
import SecondLife from "@/pages/SecondLife";
import WolfGrid from "@/pages/WolfGrid";
import NocturneRadio from "@/pages/NocturneRadio";
import Gallery from "@/pages/Gallery";
import NoticeBoard from "@/pages/NoticeBoard";
import GuestBook from "@/pages/GuestBook";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

// First-visit gate: only the root "/" is intercepted. Fresh visitors are sent to the
// Welcome flow; returning visitors (localStorage flag) go straight to Home. Direct links
// to any other internal page are never intercepted.
function HomeGate() {
  let welcomed = true;
  try { welcomed = localStorage.getItem("tavern_welcomed") === "true"; } catch (e) { welcomed = true; }
  if (!welcomed) return <Navigate to="/welcome" replace />;
  return <Home />;
}

function AppRouter() {
  const location = useLocation();
  // Detect session_id during render to handle race conditions before any other route mounts.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Welcome flow lives outside the main Layout for an immersive entry */}
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/story" element={<Story />} />
      <Route element={<Layout />}>
        <Route path="/" element={<HomeGate />} />
        <Route path="/about" element={<About />} />
        <Route path="/adventures" element={<Adventures />} />
        <Route path="/dragons-roost" element={<DragonsRoost />} />
        <Route path="/ravens" element={<MessengerRavens />} />
        <Route path="/star-charts" element={<StarCharts />} />
        <Route path="/second-life" element={<SecondLife />} />
        <Route path="/wolf-grid" element={<WolfGrid />} />
        <Route path="/radio" element={<NocturneRadio />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/notice-board" element={<NoticeBoard />} />
        <Route path="/guest-book" element={<GuestBook />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" toastOptions={{
          style: { background: "#2d1b4e", border: "1px solid rgba(212,175,55,0.35)", color: "#e0e6ed" }
        }}/>
      </BrowserRouter>
    </AuthProvider>
  );
}
